import React, { VFC } from 'react';
import { IIconProps } from './types';

const SearchIcon: VFC<IIconProps> = ({ color, size, ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M16.412 16.412 22 22"
      stroke={color}
      strokeWidth={2}
      strokeLinecap="round"
    />
    <path
      clipRule="evenodd"
      d="M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16Z"
      stroke={color}
      strokeWidth={2}
    />
  </svg>
);

export default SearchIcon;
